import { useSite } from "../context/SiteContext";
import { waLink } from "../lib/wa";

export default function TourBanner() {
  const { settings } = useSite();
  const banner = settings?.banner || { enabled: false, text: "", link: null };
  if (!banner.enabled || !banner.text) return null;

  const href = banner.link || waLink(banner.text);

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="block relative z-[45] border-y border-[rgba(201,169,97,0.35)] bg-[#0a0a0a] group"
      data-testid="tour-banner"
      onClick={() => { try { require("../lib/analytics").trackWa("banner_click"); } catch {} }}
    >
      <div className="overflow-hidden">
        <div className="banner-slide flex items-center justify-center gap-4 py-2 px-4 text-gold-2 text-xs md:text-sm tracking-[0.18em] uppercase font-medium">
          <span aria-hidden className="text-gold">◆</span>
          <span className="whitespace-nowrap text-center group-hover:text-ivory transition-colors">
            {banner.text}
          </span>
          <span aria-hidden className="text-gold">◆</span>
        </div>
      </div>
    </a>
  );
}
